export default () => {

    let forms = document.getElementsByClassName('barbaForm');
    let d;
    for (d=0; d < forms.length; d++) {
        let formId = forms[d].getAttribute('data-formid');
        let formHandle = forms[d].getAttribute('data-formhandle');
        let $form = forms[d].querySelector('.fui-form');

        // Find the CSRF token hidden input, so we can replace it
        let $csrfInput = $form.querySelector('input[name="CRAFT_CSRF_TOKEN"]');

        // Fetch the new token for the form and replace the CSRF input with our new one
        fetch('/actions/formie/forms/refresh-tokens?form=' + formHandle)
            .then(result => { return result.json(); })
            .then(result => { $csrfInput.outerHTML = result.csrf.input; console.log(result.csrf.input); });
    }
}